import { toast } from "react-toastify";
import {
  fetchCreatePORequest,
  fetchCreatePOSuccess,
  fetchCreatePOFailure,
} from "./reducer";
import { CREATE_PO } from "../../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { setSuccessMessage } from "../../toastMessage/action";

export const createPO =
  (jsonObj, setLoading, onSuccess) => async (dispatch) => {
    dispatch(fetchCreatePORequest());

    setLoading(true);

    try {
      const response = await determineBaseUrlAndPerformApiCall(
        CREATE_PO,
        "POST",
        jsonObj
      );

      if (response?.error) {
        dispatch(fetchCreatePOFailure(response.error.message));
        toast.error(response.error.message);
      } else {
        dispatch(fetchCreatePOSuccess(response));
        dispatch(setSuccessMessage(true));
        toast.success("Purchase Order recorded successfully");
        onSuccess && onSuccess();
      }
    } catch (error) {
      dispatch(fetchCreatePOFailure("Something went wrong"));

      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };